import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IReplacementFormMeta {
    replacementDate: FormInputMeta;
    replacementNewPan: FormInputMeta;
    newEffectiveDate: FormInputMeta;
    newExpirationDate: FormInputMeta;
    replacementReason: FormInputMeta;

    schema: any;
}

const replacementDataFormMeta = {} as IReplacementFormMeta;

replacementDataFormMeta.replacementDate = {
    name: "replacementDate",
    type: "date",
    label: "Date Remplacement",
    placeholder: "",
    validation: yup.date().notRequired(),
};

replacementDataFormMeta.replacementNewPan = {
    name: "replacementNewPan",
    type: "text",
    label: "Remplace. Nouv. PAN",
    placeholder: "",
    validation: yup.string(),
};

replacementDataFormMeta.newEffectiveDate = {
    name: "newEffectiveDate",
    type: "date",
    label: "Nouvelle Date Effective",
    placeholder: "",
    validation: yup.date().notRequired(),
};

replacementDataFormMeta.newExpirationDate = {
    name: "newExpirationDate",
    type: "date",
    label: "Nouvelle Date Exp.",
    placeholder: "",
    validation: yup.date().notRequired(),
};

replacementDataFormMeta.replacementReason = {
    name: "replacementReason",
    type: "text",
    label: "Motif Remplacement",
    placeholder: "",
    validation: yup.string(),
};

replacementDataFormMeta.schema = yup.object().shape(getValidationSchema(replacementDataFormMeta));

export default replacementDataFormMeta;